import styled from 'styled-components';
import { Typography } from '@material-ui/core';

import { WithMyTheme } from '@keaze/web/theme';

interface RatingProps extends WithMyTheme {
  $color: string;
}

export const Rating: any = styled(Typography)`
  ${({
    theme: {
      palette,
      typography: { pxToRem },
    },
    $color,
  }: RatingProps) => `
    display: inline-block;
    width: 37px;
    height: 25px;
    text-align: right;
    color: ${palette.common.white};
    font-weight: bold;
    font-size: ${pxToRem(10)};
    line-height: ${pxToRem(10)};
    background-color: ${$color};
    padding: 8px;
    clip-path: polygon(30% 0, 100% 0, 100% 100%, 30% 100%, 0 50%);
  `}
`;
